import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BannerType } from '../../../environments/common';

@Component({
  selector: 'card-modern',
  templateUrl: './card-modern.component.html',
  styleUrls: ['./card-modern.component.scss']
})
export class CardModernComponent  implements OnInit, AfterViewChecked {
  @Input() items: any[];
  @Input() show: boolean;
  @Input() banner: BannerType;
  @Input() page: number;

  position: number = 2;
  size: number = 11;

  bannerPosition: boolean[];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.updateBanner();
  }

  ngAfterViewChecked() {
    this.updateBanner();
    this.cdr.detectChanges(); // Marca el componente para la detección de cambios
  }

  updateBanner(){
    this.bannerPosition = Array(this.items.length).fill(false);

    for (let i = this.position; i < this.items.length; i += this.size) {
      this.bannerPosition[i] = true;
    }
    if(this.bannerPosition.length <= this.position){
      this.bannerPosition[this.bannerPosition.length-1] = true;
    }
  }

}
